// /app/frontend/src/components/frugal-v2/components/reports/reportTranslations.js
// Translations for month summary report (90 lines)

export const translations = {
  es: {
    title: "Resumen del Mes",
    loading: "Cargando reporte...",
    error: "Error al cargar reporte",
    save: "Guardar",
    saving: "Guardando...",
    saved: "Reporte guardado",
    download: "PDF",
    downloading: "Generando...",
    income: "Ingresos Totales",
    savings: "Ahorros Totales",
    expenses: "Gastos por Categoría",
    totalExpenses: "Total Gastos",
    category: "Categoría",
    amount: "Monto",
    percentage: "% del Total",
    vsLastMonth: "vs Mes Anterior",
    vs6mAvg: "vs Media 6 Meses",
    vitalAnalysis: "Análisis Consumo Vital",
    budget: "Presupuestado",
    spent: "Consumido",
    remaining: "Restante",
    consumption: "Consumo",
    budgetAnalysis: "Análisis de Presupuesto",
    trend: "Tendencia",
    increased: "Aumentó",
    decreased: "Disminuyó",
    equal: "Igual",
    noData: "Sin datos históricos",
    // Accounts section
    banks: "Bancos",
    cards: "Tarjetas de Crédito",
    currentBalance: "Saldo Actual",
    totalBankBalance: "Total en Bancos",
    maxBalance: "Máx",
    minBalance: "Mín",
    avgBalance: "Promedio",
    balanceStatsTitle: "Saldo bancario combinado del mes",
    daysLabel: "días",
    prevMonthCompare: "Comparativo mes anterior",
    thisMonth: "Mes actual",
    prevMonth: "Anterior",
    months: "meses",
    totalCardDebt: "Total Deuda Tarjetas",
    netPosition: "Posición Neta",
    noAccounts: "Sin cuentas registradas",
    // Save confirmation
    confirmSaveTitle: "Confirmar antes de guardar",
    confirmSaveMsg: "¿Has verificado que los saldos de tus cuentas (bancos y tarjetas) están actualizados? El reporte se guardará con los saldos actuales.",
    confirmSaveYes: "Sí, guardar reporte",
    confirmSaveNo: "Cancelar",
    // Scheduled charges
    upcomingCharges: "Próximos Cargos Programados",
    totalUpcoming: "Total Próximos",
    annual: "Anual",
    noScheduled: "Sin cargos programados",
    // Comparisons
    vsPreviousMonth: "Comparativo con mes anterior",
    current: "Actual",
    previous: "Anterior",
    diff: "Diferencia",
    accumulated12m: "Acumulado últimos 12 meses",
    monthlyAvg: "Promedio mensual",
    grandTotal: "Total acumulado",
    // Cashflow
    cashflowTitle: "Flujo de Caja",
    cfBalanceToday: "Saldo Bancos hoy",
    cfFinalBalance: "Saldo final proyectado",
    cfIncomingIncome: "Ingresos por venir",
    cfUpcomingExpenses: "Gastos por venir",
    cfNegativeRiskTitle: "Riesgo de saldo negativo",
    cfLowestPoint: "Punto más bajo",
    cfDate: "Fecha",
    cfConcept: "Concepto",
    cfMov: "Mov",
    cfBalance: "Saldo",
    cfEmpty: "Sin movimientos para este mes.",
    cfCalculating: "Calculando...",
    cfFooter: "Calculado a partir del saldo actual de tus cuentas bancarias. Solo lectura."
  },
  en: {
    title: "Month Summary",
    loading: "Loading report...",
    error: "Error loading report",
    save: "Save",
    saving: "Saving...",
    saved: "Report saved",
    download: "PDF",
    downloading: "Generating...",
    income: "Total Income",
    savings: "Total Savings",
    expenses: "Expenses by Category",
    totalExpenses: "Total Expenses",
    category: "Category",
    amount: "Amount",
    percentage: "% of Total",
    vsLastMonth: "vs Last Month",
    vs6mAvg: "vs 6-Month Avg",
    vitalAnalysis: "Vital Consumption Analysis",
    budget: "Budgeted",
    spent: "Spent",
    remaining: "Remaining",
    consumption: "Consumption",
    budgetAnalysis: "Budget Analysis",
    trend: "Trend",
    increased: "Increased",
    decreased: "Decreased",
    equal: "Equal",
    noData: "No historical data",
    // Accounts section
    banks: "Banks",
    cards: "Credit Cards",
    currentBalance: "Current Balance",
    totalBankBalance: "Total Bank Balance",
    maxBalance: "Max",
    minBalance: "Min",
    avgBalance: "Average",
    balanceStatsTitle: "Combined bank balance this month",
    daysLabel: "days",
    prevMonthCompare: "Previous Month Comparison",
    thisMonth: "This month",
    prevMonth: "Previous",
    months: "months",
    totalCardDebt: "Total Card Debt",
    netPosition: "Net Position",
    noAccounts: "No accounts registered",
    // Save confirmation
    confirmSaveTitle: "Confirm before saving",
    confirmSaveMsg: "Have you verified that your account balances (banks and cards) are up to date? The report will be saved with current balances.",
    confirmSaveYes: "Yes, save report",
    confirmSaveNo: "Cancel",
    // Scheduled charges
    upcomingCharges: "Upcoming Scheduled Charges",
    totalUpcoming: "Total Upcoming",
    annual: "Annual",
    noScheduled: "No scheduled charges",
    // Comparisons
    vsPreviousMonth: "Comparison vs previous month",
    current: "Current",
    previous: "Previous",
    diff: "Difference",
    accumulated12m: "Accumulated last 12 months",
    monthlyAvg: "Monthly average",
    grandTotal: "Grand total",
    // Cashflow
    cashflowTitle: "Cash Flow",
    cfBalanceToday: "Bank balance today",
    cfFinalBalance: "Projected end balance",
    cfIncomingIncome: "Upcoming income",
    cfUpcomingExpenses: "Upcoming expenses",
    cfNegativeRiskTitle: "Negative balance risk",
    cfLowestPoint: "Lowest point",
    cfDate: "Date",
    cfConcept: "Concept",
    cfMov: "Mov",
    cfBalance: "Balance",
    cfEmpty: "No movements this month.",
    cfCalculating: "Calculating...",
    cfFooter: "Calculated from your current bank balance. Read-only."
  }
};

export const categoryNames = {
  es: {
    "Alimentacion": "Alimentación", "Salud": "Salud", "Transporte/Mantenimiento": "Transporte",
    "Suscripciones": "Suscripciones", "Entretenimiento": "Entretenimiento", "Vivienda": "Vivienda",
    "Servicios": "Servicios", "Educacion": "Educación", "Otros": "Otros"
  },
  en: {
    "Alimentacion": "Food", "Salud": "Health", "Transporte/Mantenimiento": "Transportation",
    "Suscripciones": "Subscriptions", "Entretenimiento": "Entertainment", "Vivienda": "Housing",
    "Servicios": "Utilities", "Educacion": "Education", "Otros": "Other"
  }
};
